import * as React from 'react';
import { useAppSelector } from '../../store';
import { UserRole } from '../../store/auth';
import { useNavigate } from 'react-router-dom';

export default function ProtectedRoute({ role, children }: { role: UserRole; children: React.ReactNode }) {
  const navigate = useNavigate();
  const { role: userRole } = useAppSelector((state) => state.auth);

  function userHasPermission(requiredRole: UserRole): boolean {
      return requiredRole === userRole;
  }

  React.useEffect(() => {
    if (!userHasPermission(role as UserRole)) {
      return navigate('/unauthorized', { replace: true });
    }
  }, []);

  return <>{children}</>;
}